export const LOAN_APPLICATIONS_ENDPOINTS = {
    activeLoans: '/loan-applications/me/active',
    allLoans: '/loan-applications/me',
    paymentSchedule: '/loan-applications/:id/payment-schedule',
    createLoan: '/loan-application',
};
